// 上传列表
import { useContext } from "react"
import { AppContext } from "Views/Home/context"
import { Material } from "Types/material"
import { useSwitch, useMark, useAssign } from "Hooks/basic"
import { checkUserPrivilege } from "Methods/privilege"
import request from "Methods/request"

export function useBomTable(handleChangeItem: any) {
    // 弹窗开关
    const { open, toggle } = useSwitch(false)
    // 弹窗修改数据
    const {
        object: modifyData,
        handleChange: handleChangeData,
    } = useAssign<Material | null>(null)
    // 当前修改数据索引
    const {
        mark: editIndex,
        handleChangeMark: handleChangeEditIndex,
    } = useMark(-1)
    // 用户权限
    const { privilegeMap } = useContext(AppContext)
    const { update = false } = checkUserPrivilege(privilegeMap, "material")
    // 弹窗属性
    const dialogProps = {
        open,
        modifyData,
        update,
        handleClose: () => {
            toggle(false)
        },
        handleConfirm: async (editData: Material) => {
            toggle(false)

            // 网络图片链接转码至我们的七牛
            if(editData.head_img && editData.head_img.url && editData.head_img.url.indexOf('i-young.guokr.net') < 0) {
                const {data} = await request.post("/apis/covert_qiniu_url", {
                    url: editData.head_img.url
                })
                return await handleChangeItem(editIndex, {
                    ...editData,
                    head_img: {
                        name:`网络转码.${data.file_type.split('/').pop()}`,
                        url: data.qiniu_url
                    }
                })
            }
            await handleChangeItem(editIndex, editData)
        },
    }
    return {
        toggle, handleChangeData, handleChangeEditIndex,
        dialogProps, update,
    }
}

